import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Smoothly scrolls to an element with an optional offset
 * @param elementId - The ID of the element to scroll to (without the # symbol)
 * @param offset - The offset from the top in pixels (default: 64 for sticky nav)
 */
export function smoothScrollToElement(elementId: string, offset: number = 64) {
  const element = document.querySelector(`#${elementId}`)
  if (element) {
    const elementPosition = element.getBoundingClientRect().top + window.scrollY
    const offsetPosition = elementPosition - offset

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    })
  }
}

/**
 * Sets up smooth scroll behavior for all hash anchor links on the page
 * @param offset - The offset from the top in pixels (default: 64 for sticky nav)
 * @returns Cleanup function to remove the event listener
 */
export function setupSmoothScroll(offset: number = 64) {
  const handleHashClick = (e: MouseEvent) => {
    const target = e.target as HTMLElement
    const anchor = target.closest('a[href^="#"]')

    if (anchor) {
      e.preventDefault()
      const href = anchor.getAttribute('href')
      if (href === '#') {
        // Scroll to top of page
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      } else if (href && href.length > 1) {
        const elementId = href.substring(1)
        smoothScrollToElement(elementId, offset)
      }
    }
  }

  document.addEventListener('click', handleHashClick)
  return () => document.removeEventListener('click', handleHashClick)
}
